"use strict";

require("core-js/modules/es.array.flat");

require("core-js/modules/es.array.unscopables.flat");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

exports.__esModule = true;
exports.normalizeByStation = exports.normalizeByGps = void 0;

var E = __importStar(require("fp-ts/lib/Either"));

var util_1 = require("../../util");
/**
 * Normalize aqicn byGps data
 *
 * @param data - The data to normalize
 */


function normalizeByGps(data) {
  var results = data.results;

  if (!results.length) {
    return E.left(util_1.providerError('openaq', 'Cannot normalize, got 0 result'));
  }

  return E.right(results.map(function (result) {
    return result.measurements.map(function (m) {
      return __assign(__assign({}, m), {
        city: result.city,
        coordinates: result.coordinates,
        country: result.country,
        date: {
          local: m.lastUpdated,
          utc: m.lastUpdated
        },
        location: "openaq|" + result.location
      });
    });
  }).flat());
}

exports.normalizeByGps = normalizeByGps;
/**
 * Normalize aqicn byGps data
 *
 * @param data - The data to normalize
 */

function normalizeByStation(data) {
  var results = data.results;

  if (!results.length) {
    return E.left(util_1.providerError('openaq', 'Cannot normalize, got 0 result'));
  }

  return E.right(results.map(function (result) {
    return __assign(__assign({}, result), {
      location: "openaq|" + result.location
    });
  }));
}

exports.normalizeByStation = normalizeByStation;